import styled from 'styled-components';
import { Typ30 } from 'dc/Typ';

export const TermsWrapper = styled.div`
  padding: 0 16px 16px;
  display: flex;
  flex-direction: column;
  background-color: #f9fcff;
  border-radius: 5px;
  border: 1px solid #e2e6e8;
  li {
    font-size: 14px;
    line-height: 20px;
    font-weight: normal;
    color: #263238;
    margin: 0;
  }
  a {
    color: #007079;
    text-decoration: underline;
  }
`;

export const Updated = styled(Typ30)``;

export const Tracking = styled.iframe`
  height: 200px;
  max-width: 100%;
  margin: 16px;
  border: 1px solid #e2e6e8;
  border-radius: 5px;
`;
